import { useEffect } from 'react'
import { logout } from 'actions/auth'
import Spinner from 'components/utils/Spinner'
import { useAppDispatch } from 'store/hooks'

const Logout = () => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    Promise.resolve()
      .then(() => dispatch(logout() as any))
      .then(() => {
        window.location.href = '/login'
      })
  }, [dispatch])

  return <Spinner show={true} header="Logging you out" />
}

export default Logout
